import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { holidayYearJson } from "../../../DynamicFormsJson/MastersJSON/holidayYear";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { compose } from "recompose";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";

class HolidayYearForm extends React.Component {
    constructor(props) {
        super(props);
    }
    callBeforeSaveMethod = async (dataToSave, editData) => {
        if (
            Object.keys(editData).length == 0 ||
            (Object.keys(editData).length != 0 &&
                editData.fromDate != dataToSave.fromDate)
        ) {
            let typeData = Object.keys(editData).length == 0 ? "0" : "1";
            let id = typeData == 0 ? "" : this.props.params.id;

            const { showLoador, showNotification } = this.props;
            const fromDateArr = dataToSave.fromDate.split("-");
            const toDateArr = dataToSave.toDate.split("-");
            if (fromDateArr[1].length < 2) fromDateArr[1] = "0" + fromDateArr[1];
            if (fromDateArr[0].length < 2) fromDateArr[0] = "0" + fromDateArr[0];
            if (toDateArr[1].length < 2) toDateArr[1] = "0" + toDateArr[1];
            if (toDateArr[0].length < 2) toDateArr[0] = "0" + toDateArr[0];
            const newFromDate = [fromDateArr[0], fromDateArr[1], fromDateArr[2]].join(
                "-"
            );
            const newToDate = [toDateArr[0], toDateArr[1], toDateArr[2]].join("-");
            if (navigator.onLine) {
                showLoador({ loador: true });
                const response = await apiGet({
                    url:
                        holidayYearJson.apiBaseURL +
                        "/exist-or-not?fromDate=" +
                        newFromDate +
                        "&toDate=" +
                        newToDate +
                        "&type=" +
                        typeData + "&id=" + id,
                }).then(({ data, success }) => {
                    if (success) {
                        if (data.data.error) {
                            showNotification({
                                msg: data.data.message,
                                severity: "error",
                            });
                        }
                        return !data.data.error;
                    }
                    return false;
                });
                showLoador({ loador: false });

                return response;
            } else {
                showNotification({ msg: noInternetMsg, severity: "error" });
            }
        }
        return true;
    };
    render() {
        return (
            <>
                <DynamicForm
                    callBeforeSave={true}
                    callBeforeSaveMethod={this.callBeforeSaveMethod}
                    formPath={holidayYearJson.formPath}
                    screenTitle={holidayYearJson.screenTitle}
                    fieldMeta={holidayYearJson.fieldMeta}
                    apiBaseURL={holidayYearJson.apiBaseURL}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(HolidayYearForm);
